import { IconButton, Stack, Tooltip, Typography, Box } from '@mui/material';
import { WhatsApp, Telegram } from '@mui/icons-material';
import Logo from '../icons/Logo';
import type { SupportContacts } from '../../types/support';

const styles = {
  root: {
    backgroundColor: '#1C1C20',
    py: { xs: 1.5, md: 4 },
    px: { xs: 1.5, md: 2 },
    justifyContent: 'space-around',
    alignItems: 'center',
    gap: { xs: 1, md: 2 },
    width: '100%',
    minWidth: 0,
    flexShrink: 0,
    display: 'flex',
    flexWrap: 'nowrap',
  },
  logo: {
    minWidth: 64,
    width: { xs: 64, md: 96 },
    flexShrink: 0,
    overflow: 'hidden',
    '& img': {
      display: 'block',
      width: '100%',
      height: 32,
      objectFit: 'contain',
    },
    '& .MuiTypography-root': {
      fontSize: { xs: '16px', md: '24px' },
      maxWidth: '100%',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
  },
  socialLinks: {
    display: 'flex',
    alignItems: 'center',
    flexShrink: 0,
  },
};

const CasinoFooter = ({ contacts }: { contacts: SupportContacts }) => {
  const socialLinks = [
    ...(contacts.whatsapp ? [{ ...contacts.whatsapp, icon: <WhatsApp />, label: 'WhatsApp', color: '#25D366' }] : []),
    ...(contacts.telegram ? [{ ...contacts.telegram, icon: <Telegram />, label: 'Telegram', color: '#fff' }] : []),
  ];

  return (
    <Stack component='footer' direction='row' sx={styles.root}>
      <Box sx={styles.logo}>
        <Logo size='small' />
      </Box>
      {socialLinks.map((social) => (
        <Box key={social.label} sx={styles.socialLinks}>
          <Tooltip title={social.label}>
            <IconButton
              aria-label={social.label}
              component='a'
              href={social.url}
              target='_blank'
              rel='noopener noreferrer'
              sx={{
                color: social.color,
                '&:hover': { opacity: 0.8 },
                '& .MuiSvgIcon-root': { fontSize: { xs: '1.5rem', md: '2rem' } },
              }}
            >
              {social.icon}
            </IconButton>
          </Tooltip>
          {social.displayText && (
            <Typography
              variant='body2'
              sx={{
                color: social.color,
                ml: { xs: 0, md: 0.5 },
                fontSize: { xs: '12px', md: '14px' },
                whiteSpace: 'nowrap',
              }}
            >
              {social.displayText}
            </Typography>
          )}
        </Box>
      ))}
    </Stack>
  );
};

export default CasinoFooter;
